import { Button } from '@albelli/arc-3-react/lib/Button';
import { useState, useEffect, useContext } from 'preact/hooks';
import Cookie from 'js-cookie';
import Trans from '../translations/trans';
import { vendors } from '../../config/vendor';
import { editorConfigMobile, editorConfigMobileBeta } from '../../config/editorConfig';
import useVendor from '../../hooks/useVendor';
import { getQueryParameters, updateUrlParameter, getSEOReferrerEngine } from '../../helpers/utils';
import StorefrontRoutesContext from './storefrontRoutesContextContext';

const EditorButton = ({ promotionUrl, articleTypes, campaignUuid }) => {
    const vendor = useVendor();
    const appStoreLang = vendors[vendor].locale.substring(0, 2);
    const [appStoreButtonUrlIos, setAppStoreButtonUrlIos] = useState(vendors[vendor].appDeeplinkIos);
    const [appStoreButtonUrlAndroid, setAppStoreButtonUrlAndroid] = useState(vendors[vendor].appDeeplinkAndroid);

    const sfpRoutes = useContext(StorefrontRoutesContext);

    useEffect(() => {
        const trackingCode = getTrackingCode();
        const cloudVisitorID = Cookie.get('cust_val_mcid') || null;
        if (trackingCode) {
            setAppStoreButtonUrlIos((url: string) => {
                const urlWithCampaign = updateUrlParameter(url, 'utm_campaign', trackingCode);
                return updateUrlParameter(urlWithCampaign, 'c', trackingCode);
            });
            setAppStoreButtonUrlAndroid((url: string) => {
                const urlWithCampaign = updateUrlParameter(url, 'utm_campaign', trackingCode);
                return updateUrlParameter(urlWithCampaign, 'c', trackingCode);
            });
        }

        if (cloudVisitorID) {
            setAppStoreButtonUrlIos((url: string) => updateUrlParameter(url, 'mcid', cloudVisitorID));
            setAppStoreButtonUrlAndroid((url: string) => updateUrlParameter(url, 'mcid', cloudVisitorID));
        }

        if (campaignUuid) {
            setAppStoreButtonUrlIos((url: string) => updateUrlParameter(url, 'cm_campaign', campaignUuid));
            setAppStoreButtonUrlAndroid((url: string) => updateUrlParameter(url, 'cm_campaign', campaignUuid));
        }

        if (sfpRoutes && articleTypes) {
            const articleTypeUrl = sfpRoutes[Object.keys(articleTypes)[0]];
            if (articleTypeUrl) {
                setAppStoreButtonUrlIos((url: string) => updateUrlParameter(url, 'deep_link_value', articleTypeUrl));
                setAppStoreButtonUrlAndroid((url: string) =>
                    updateUrlParameter(url, 'deep_link_value', articleTypeUrl)
                );
            }
        }
    }, []);

    const getTrackingCode = () => {
        const queryParams = getQueryParameters(location.search.substr(1));

        if (queryParams['utm_campaign']) {
            return queryParams['utm_campaign'];
        }

        const seoReferrerEngine = getSEOReferrerEngine();
        if (seoReferrerEngine) {
            const value = `SEO - non Branded:${seoReferrerEngine}:keyword unavailable`;
            Cookie.set('network', value, {
                expires: 90,
                domain: process.env.APP_ENV === 'dev' ? undefined : `.${vendor}`,
            });
            return value;
        }

        const networkCookie = Cookie.get('network');
        if (networkCookie) {
            return networkCookie;
        }

        return null;
    };

    let config = editorConfigMobile[Object.keys(articleTypes)[0]] ?? [];
    // Remove this once Everest app supports books CMS-16820
    if (
        [
            'photobox.co.uk',
            'photobox.fr',
            'photobox.ie',
            'photobox.it',
            'photobox.dk',
            'hofmann.es',
            'hofmann.pt',
        ].includes(vendor)
    ) {
        config = editorConfigMobileBeta[Object.keys(articleTypes)[0]] ?? [];
    }

    return (
        <>
            {config.includes('app') ? (
                <div className='arc3-hide-for-large'>
                    <a className='arc3-hide filter-ios' rel='noreferrer' href={appStoreButtonUrlIos}>
                        <div className={`arc3-app-store-btn arc3-app-store-btn--ios-${appStoreLang}`} />
                    </a>
                    <a className='arc3-hide filter-android' rel='noreferrer' href={appStoreButtonUrlAndroid}>
                        <div className={`arc3-app-store-btn arc3-app-store-btn--android-${appStoreLang}`} />
                    </a>
                </div>
            ) : (
                ''
            )}

            {config.includes('online') ? (
                <Button
                    className='arc3-btn arc3-form__inline-btn arc3-hide-for-large arc3-margin--right arc3-margin--left'
                    href={promotionUrl}
                >
                    <Trans transKey='product.getStartedButtonTitle' />
                </Button>
            ) : (
                ''
            )}

            <Button
                className='arc3-btn arc3-form__inline-btn arc3-hide-for-medium-down arc3-margin--right arc3-margin--left'
                href={promotionUrl}
            >
                <Trans transKey='product.getStartedButtonTitle' />
            </Button>
        </>
    );
};

export default EditorButton;
